module.exports = "<button class=\"kuiButton kuiButton--basic kuiButton--iconText\">\n  <span class=\"kuiButton__icon kuiIcon fa-gear\"></span>\n  Settings\n</button>\n\n<hr class=\"guideBreak\">\n\n<button class=\"kuiButton kuiButton--basic\">\n  <span class=\"kuiButton__icon kuiIcon fa-gear\"></span>\n</button>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/guide/views/button/button_with_icon.html
 ** module id = 724
 ** module chunks = 0
 **/